import {useTranslation} from "react-i18next";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    InputAdornment,
    TextField,
    Typography
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMore";
import {intToFloatCurrency} from "../Utils";
import { useTaxConfigurationAccordionValues } from "../useTaxConfigurationAccordionValues";

interface TaxConfiguration {
    railwayStationTax?: string;
    roadTax?: string;
    airportTax?: string;
    airportRailwayStationTax?: number;
    roadTaxDailyValue?: string;
    reservedPricing?: string;
}

interface TaxConfigurationDetailProps {
    taxConfiguration: TaxConfiguration;
}

const TaxConfigurationDetail = ({taxConfiguration}: TaxConfigurationDetailProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'taxConfiguration'});

    const {reservationValues,surchargesValues} = useTaxConfigurationAccordionValues();
   
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreRoundedIcon/>}>
                <Typography>{t('title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.railwayStationTax')}
                            value={surchargesValues.find(el => el.value === taxConfiguration.railwayStationTax)?.label ?? '--'}
                            InputProps={{readOnly: true}}
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.roadTax')}
                            value={surchargesValues.find(el => el.value === taxConfiguration.roadTax)?.label ?? '--'}
                            InputProps={{readOnly: true}}
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.airportTax')}
                            value={surchargesValues.find(el => el.value === taxConfiguration.airportTax)?.label ?? '--'}
                            InputProps={{readOnly: true}}
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={3}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.airportRailwayStationTax')}
                            value={taxConfiguration.airportRailwayStationTax ? taxConfiguration.airportRailwayStationTax : '--'}
                            InputProps={{
                                readOnly: true,
                                endAdornment: <InputAdornment position={'start'}>%</InputAdornment>
                            }}
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.roadTaxDailyValue')}
                            value={taxConfiguration.roadTaxDailyValue ? intToFloatCurrency(taxConfiguration.roadTaxDailyValue) : '--'}
                            InputProps={{readOnly: true}}
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.reservedPricing')}
                            value={reservationValues.find(el => el.value === taxConfiguration.reservedPricing)?.label ?? '--'}
                            InputProps={{readOnly: true}}
                        >
                        </TextField>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default TaxConfigurationDetail